import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, Grid, Box, TextField, FormControl, InputLabel, Select, MenuItem,
  Button, LinearProgress, Divider, Snackbar, Alert
  
} from '@mui/material';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useOperational } from 'providers/OperationalContextProvider'; 

export default function ClientsForm({ open = false, onClose, data = null, onOrderUpdated }) {

    const { postClients} = useOperational();
    const [snackbarState, setSnackbarState] = React.useState({ open: false, message: "", status: "info" });
    const [loading, setLoading] = React.useState(false);
    const [enabled, setEnabled] = React.useState(data?.enabled ?? true);

    const formatFirebaseDate = (firebaseDate) => {
        if (!firebaseDate || !firebaseDate._seconds) return '';
        const date = new Date(firebaseDate._seconds * 1000);
        return date.toISOString().split('T')[0];
    };
    const columns =[
        { id: 'id', label: 'Id', defaultValue: data?.id ?? '', disabled: true, type: 'text', xs: 4, sm: 4, md: 4 },
        { id: 'tenant_id', label: 'Tenant Id', defaultValue: data?.tenant_id ?? '', disabled: true, type: 'text', xs: 4, sm: 4, md: 4 },
        { id: 'email', label: 'Email', defaultValue: data?.email ?? '', type: 'text', disabled: false, xs: 4, sm: 4, md: 4 },
        { id: 'password', label: 'Password', defaultValue: data?.password ?? '', type: 'text', disabled: false, xs: 4, sm: 4, md: 4 },
        { id: 'name', label: 'Name', defaultValue: data?.name ?? '', disabled: false, type: 'text', xs: 12, sm: 4, md: 4 },
        { id: 'last_name', label: 'Last Name', defaultValue: data?.last_name ?? '', disabled: false, type: 'text', xs: 12, sm: 4, md: 4 },
        { id: 'telephone', label: 'Telephone', defaultValue: data?.telephone ?? '', disabled: false, type: 'text', xs: 12, sm: 4, md: 4 },
        { id: 'image_url', label: 'image_url', defaultValue: data?.image_url ?? '', disabled: true, type: 'text', xs: 6, sm: 4, md: 4 },
        { id: 'created_at', label: 'Created At', defaultValue: formatFirebaseDate(data?.created_at), disabled: true, type: 'date', xs: 6, sm: 4, md: 4 },
        { id: 'updated_at', label: 'Update At', defaultValue: formatFirebaseDate(data?.updated_at), disabled: true, type: 'date', xs: 6, sm: 4, md: 4 },
    ];

    const handleClose = (reason) => {
        if (reason === 'clickaway') return;
        setSnackbarState({ ...snackbarState, open: false });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const email = formData.get("email");
        const password =  formData.get("password");
        const name = formData.get("name");
        const lastName =  formData.get("last_name");
        const telephone =  formData.get("telephone");

        if (!email) return showError("email");
        if (!password) return showError("password");
        if (!name) return showError("name");
        if (!lastName) return showError("lastName");
        if (!telephone) return showError("telephone");
        if (enabled === null || enabled === undefined) return showError("enabled");
        
        const requestBody = {
        
            email: email,
            password: password,
            name: name,
            last_name: lastName,
            telephone: telephone,
            enabled: enabled,
        };
        setLoading(true);
        try {
            await postClients(requestBody)
            onOrderUpdated()
        } catch (err) {
            setSnackbarState({open:true, message: err.message, status: "error"})
        } finally {
            setLoading(false);
        }
       
    };

    function showError(field) {
      setSnackbarState({ 
        open: true, 
        message: `Complete the required field: ${field}`, 
        status: 'warning' 
      });
      setLoading(false);
    }

    return (
         <React.Fragment>
           <Dialog 
                open={open} 
                onClose={onClose} 
                maxWidth="md" 
                fullWidth
                scroll="paper"
            >
                <DialogTitle sx={{ m: 0, p: 2, pr: 6 }}>
                    {data ? "Editing Client" : "Adding Client"}
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                            '&:hover': {
                                color: 'error.main', 
                            }
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                {loading ? <LinearProgress /> : <Divider />}
                <DialogContent sx={{ p: 3 }}> 
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={12}>
                            <Box component="form" noValidate onSubmit={handleSubmit}>
                                <Grid container spacing={2}>
                                    {columns.map((column) => (
                                        <Grid item key={column.id} xs={column.xs} sm={column.sm} md={column.md}>
                                            <TextField
                                                disabled={column.disabled}
                                                size='small'
                                                required
                                                fullWidth
                                                id={column.id}
                                                name={column.id}
                                                defaultValue={column.defaultValue}
                                                type={column.type}
                                                hiddenLabel
                                                variant="outlined"
                                                aria-label={column.label}
                                                placeholder={column.label}
                                                InputProps={{
                                                    readOnly: column.disabled,
                                                }}
                                                inputProps={{
                                                    autoComplete: 'new-password', 
                                                }}
                                            />
                                        </Grid>
                                    ))}
                                    <Grid item xs={12} sm={6}>
                                        <FormControl fullWidth required size="small">
                                            <InputLabel id="status-label">Estado</InputLabel>
                                            <Select
                                                labelId="status-label"
                                                id="status"
                                                value={enabled}
                                                onChange={(e) => setEnabled(e.target.value)}
                                            >
                                                <MenuItem value={true}>Activo</MenuItem>
                                                <MenuItem value={false}>Inactivo</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Button type="submit" fullWidth variant="contained" sx={{ mt: 3 }}>
                                    {data? "UPDATE CLIENT": "ADD CLIENT"}
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
            <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={snackbarState.open} onClose={handleClose} autoHideDuration={3000}>
                <Alert onClose={handleClose} severity={snackbarState.status} variant="filled">
                    {snackbarState.message}
                </Alert>
            </Snackbar>
        </React.Fragment>
    );
}
